import { HTMLAttributes, ReactNode } from 'react'


import { HelperText } from './styles'

interface IProps extends HTMLAttributes<HTMLSpanElement> {
  isInvalid?: boolean
  children: ReactNode
}

export function FieldHelperText({
  children,
  isInvalid = false,
  ...rest
}: IProps) {
  return (
    <HelperText isInvalid={isInvalid} isVisible={isInvalid} {...rest}>
      {children}
    </HelperText>
  )
}
